import './zubie-spinner-rings';
import {LitElement, html, css} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {GeocodedAddress, reverseGeocode} from './services/geocode';

@customElement('zubie-geo-address')
export class ZubieGeoAddress extends LitElement {
  static override styles = css`
    .spinner {
      display: inline-block;
      color: #5742e0;
    }
  `;

  @property({type: String})
  city = '';

  @property({type: Number})
  latitude?: number;

  @property({type: Number})
  longitude?: number;

  @property({type: String})
  state = '';

  @property({type: String})
  street = '';

  @state()
  private isLoading = false;

  override connectedCallback() {
    super.connectedCallback();
  }

  override firstUpdated() {
    if (!this.city && !this.state && !this.street) {
      this.reverseGeocode();
    }
  }

  async reverseGeocode() {
    if (this.latitude && this.longitude) {
      this.isLoading = true;

      try {
        const address = await reverseGeocode(this.longitude, this.latitude);
        this.setAddress(address);
      } catch (error) {
        if (error instanceof Error) {
          let eventName = 'error';
          if (error.message === 'Address not found') {
            eventName = 'address-not-found';
          }

          this.dispatchEvent(
            new CustomEvent(eventName, {
              detail: {
                message: error.message,
                latitude: this.latitude,
                longitude: this.longitude,
              },
              bubbles: true,
              composed: true,
            })
          );
        }
      }

      this.isLoading = false;
    }
  }

  setAddress(address: GeocodedAddress) {
    this.street = address.street;
    this.city = address.city;
    this.state = address.state;
  }

  override render() {
    return this.isLoading
      ? html`<zubie-spinner-rings
          class="spinner"
          height="22px"
          width="22px"
        ></zubie-spinner-rings>`
      : html` <div class="geocoded-address roboto-medium" data-t="address">
          <div class="geocoded-street q-mb-xs" data-t="street">
            ${this.street}
          </div>
          <div class="geocoded-city-state q-mt-xs">
            ${this.city}${this.city && this.state ? ', ' : ''}${this.state}
          </div>
        </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'zubie-geo-address': ZubieGeoAddress;
  }
}
